import styled from 'styled-components';

// CONSTANTS
import { MISCHKA } from '@/constants/colors';

export const Wrapper = styled.div`
  .search,
  &.search {
    &__anchors {
      margin-bottom: 24px;
    }

    &__container {
      position: relative;
      padding: 0;
      min-height: calc(100vh - 348px);
    }

    .filters {
      &__search {
        .MuiInputBase-root {
          font-size: 1.8rem;
          font-weight: 400;
          padding: 9px 15px;

          input {
            padding: 5px 0 5px 10px;
          }
        }
        &__icon {
          color: inherit;
          font-size: 2rem;
          margin-top: 0;
        }
      }
    }

    &__divider {
      background-color: ${MISCHKA};
    }
  }
`;

export default Wrapper;
